export const WIZARD_EVENTS = Object.freeze({
    NEXT: "NEXT",
    PREV: "PREV",
    GOTO: "GOTO",
});

const clampStep = (step, totalSteps) =>
    Math.max(1, Math.min(Number(totalSteps) || 1, Number(step) || 1));

export const transitionWizardStep = ({
    currentStep,
    event,
    totalSteps,
    blockReason = null,
    targetStep = null,
}) => {
    const safeCurrent = clampStep(currentStep, totalSteps);

    if (event === WIZARD_EVENTS.NEXT) {
        if (blockReason) {
            return {
                step: safeCurrent,
                blocked: true,
                blockReason,
            };
        }
        return {
            step: clampStep(safeCurrent + 1, totalSteps),
            blocked: false,
            blockReason: null,
        };
    }

    if (event === WIZARD_EVENTS.PREV) {
        return {
            step: clampStep(safeCurrent - 1, totalSteps),
            blocked: false,
            blockReason: null,
        };
    }

    if (event === WIZARD_EVENTS.GOTO) {
        const nextStep = clampStep(targetStep, totalSteps);
        const goingForward = nextStep > safeCurrent;
        if (goingForward && blockReason) {
            return {
                step: safeCurrent,
                blocked: true,
                blockReason,
            };
        }
        return {
            step: nextStep,
            blocked: false,
            blockReason: null,
        };
    }

    return {
        step: safeCurrent,
        blocked: false,
        blockReason: null,
    };
};
